"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _dateTimeHelpers = require("./dateTimeHelpers");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var has = _lodash.default.negate(_lodash.default.isUndefined);

var isEndsAfter = function isEndsAfter(props) {
  return has(props.endingAfter) && !has(props.starting);
};

var isStartsOn = function isStartsOn(props) {
  return !has(props.endingAfter) && has(props.starting);
};

var isRunsBetween = function isRunsBetween(props) {
  return has(props.endingAfter) && has(props.starting);
};

var entireDayOf = function entireDayOf(timeString) {
  return timeString + "T23:59:59";
};

var dateOnlyAssumptionFixer = function dateOnlyAssumptionFixer(timeString) {
  return (0, _dateTimeHelpers.isDateOnly)(timeString) ? entireDayOf(timeString) : timeString;
};

var hasNotEnded = function hasNotEnded(date) {
  return date !== undefined && (0, _moment.default)().isSameOrBefore(dateOnlyAssumptionFixer(date));
};

var hasStarted = function hasStarted(date) {
  return date !== undefined && (0, _moment.default)().isSameOrAfter(date);
};

var isAfter = function isAfter(date) {
  return date !== undefined && (0, _moment.default)().isAfter(dateOnlyAssumptionFixer(date));
};

var endsAfter = function endsAfter(_a) {
  var children = _a.children,
      endingAfter = _a.endingAfter;
  var active = hasNotEnded(endingAfter);
  return {
    children: children,
    active: active,
    unnecessary: !active
  };
};

var startsOn = function startsOn(_a) {
  var children = _a.children,
      starting = _a.starting;
  var active = hasStarted(starting);
  return {
    children: children,
    active: active,
    unnecessary: active
  };
};

var runsBetweenTwoDates = function runsBetweenTwoDates(_a) {
  var children = _a.children,
      starting = _a.starting,
      endingAfter = _a.endingAfter;
  var active = hasStarted(starting) && hasNotEnded(endingAfter);
  return {
    children: children,
    active: active,
    unnecessary: isAfter(endingAfter)
  };
};

var hasNoDates = function hasNoDates(_a) {
  var children = _a.children,
      _b = _a.explodeWithNoDates,
      explodeWithNoDates = _b === void 0 ? true : _b;

  if (explodeWithNoDates) {
    throw new Error("You didn't give me enough props! I need at least either a starting date or an ending after date.");
  } else {
    return {
      children: children,
      active: true,
      unnecessary: true
    };
  }
};

var tap = function tap(f) {
  return function (t) {
    f(t);
    return t;
  };
};

var validateProps = tap(function (props) {
  if (isRunsBetween(props)) {
    (0, _dateTimeHelpers.assertIso8601ish)(props.starting);
    (0, _dateTimeHelpers.assertIso8601ish)(props.endingAfter);
  }

  if (isStartsOn(props)) {
    (0, _dateTimeHelpers.assertIso8601ish)(props.starting);
  }

  if (isEndsAfter(props)) {
    (0, _dateTimeHelpers.assertIso8601ish)(props.endingAfter);
  }
});
var warnAboutUnneededSchedules = tap(function (_a) {
  var unnecessary = _a.unnecessary;
  var runningLocally = process.env.NODE_ENV === 'development';

  if (unnecessary && runningLocally) {
    /* tslint:disable:no-console */
    console.warn('AirSchedule is no longer needed since we have entered a state of permanency.');
  }
});

var render = function render(_a) {
  var active = _a.active,
      children = _a.children;
  return React.createElement(React.Fragment, null, active && children);
};

var determineAiringInstructions = _lodash.default.cond([[isEndsAfter, endsAfter], [isStartsOn, startsOn], [isRunsBetween, runsBetweenTwoDates], [_lodash.default.stubTrue, hasNoDates]]);
/** A component to show its children on a given time schedule
 *
 * A `starting` date and/or `endingAfter` date needs to be provided. Schedules can:
 * - run forever after a starting date/time
 * - run up until an ending date/time
 * - run between two specified times
 *
 * Dates must be similar to ISO8601, but contain only the date and optionally the time.
 *
 * Example dates:
 * - 2010-02-03 -- Only a date
 * - 2010-02-03T12:34:56 -- A date and a local time of the browser
 * - 2010-02-03T12:34:56-04:00 -- A date and time, with a supplied timezone
 * - 2010-02-03T12:34:56Z -- A date and a GMT time
 */


var AirSchedule = _lodash.default.flow(validateProps, determineAiringInstructions, warnAboutUnneededSchedules, render);

var _default = AirSchedule;
exports.default = _default;